import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {map} from 'rxjs/operators';


@Injectable()
export class PaymentsService {


  constructor(private apiService: ApiService) {
  }

  get(id) {
    return this.apiService.get(`/payments/${id}`)
      .pipe(
        map((result) => result.data)
      );
  }

  create(payment) {
    const paymentDate = new Date(payment.payment_date);

    payment.payment_date = `${paymentDate.getMonth() + 1}/${paymentDate.getDate()}/${paymentDate.getFullYear()}`;

    return this.apiService.post(`/payments`, payment)
      .pipe(
        map((result) => result.data)
      );
  }

  update(id, payment) {
    const paymentDate = new Date(payment.payment_date);

    payment.payment_date = `${paymentDate.getMonth() + 1}/${paymentDate.getDate()}/${paymentDate.getFullYear()}`;
    return this.apiService.put(`/payments/${id}`, payment);
  }

  destroy(id) {
    return this.apiService.delete(`/payments/${id}`);
  }

}
